module.exports = "<div class=modal-header> <h3 class=modal-title>Reset Editor Setting</h3> </div> <div class=modal-body> <p>Are you sure you want to reset the editor settings?</p> <p>You can not undo after you reset.</p> </div> <div class=modal-footer> <button class=\"btn btn-warning\" ng-click=cancel()>No</button> <button class=\"btn btn-primary\" ng-click=ok()>Yes</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./templates/reset-editor.html
// module id = 397
// module chunks = 0